import Vue from 'vue'
import App from './App.vue'
import { Button, Row, Col, Dropdown, Menu, Icon, Checkbox, Radio } from 'ant-design-vue';
import * as filters from './filters'
import GeminiScrollbar from 'vue-gemini-scrollbar' // 自定义滚动条
import femonitorVue from 'femonitor-vue'

Vue.use(GeminiScrollbar)

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(Radio)

femonitorVue(Vue)

if (window.feMonitor) {
    try {
        feMonitor.setConfig({
            sampleRate: 0.1,
            isCollectPerformance: true,
            title: 'PCF10资金分析',
        })
    }catch(e){
        console.log(e)
    }
}

Vue.config.productionTip = false

/* 全局注册filters */
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

window.D3Charts.track(false)
window.TA.log({
    id: 'webhsgt_show'
})

// window.retheme = (newtheme) => {
//     if(newtheme == 'newblack' || newtheme == 'newgrey'){
//         document.getElementsByTagName('body')[0].className=newtheme
//     }else{
//         document.getElementsByTagName('body')[0].className=null
//     }
//     window.fundSharing(newtheme)
//     window.fundHistory(newtheme)
// }

new Vue({
    render: h => h(App),
}).$mount('#app')